export default __webpack_public_path__ + "static/media/bg_daftar_pengetahuan_mobile.6b049371.webp";